// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBHhh60J-eIzSDAurcUyPPrR1n96WVP_sg",
  authDomain: "urbanmix-home.firebaseapp.com",
  projectId: "urbanmix-home",
  storageBucket: "urbanmix-home.appspot.com",
  messagingSenderId: "15891584987",
  appId: "1:15891584987:web:9d7e766948c00a4c6279fe",
  measurementId: "G-1JS221L89Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);